<div class="admin-auditlog">
    <page-header icon="fas fa-clock"
                 header="{{'Audit Log' | translate}}"
                 [subHeader]="getSubHeaderText()"></page-header>
    <div class="card panel-monsido-card">
        <div class="card-header">
            <form (ngSubmit)="submit($event)" #form="ngForm" class="pt-5">
                <div class="row">
                    <div class="col-48 col-md-8 pr-0">
                        <form-field-select
                            size="medium"
                            label="Domains"
                            [hideLabel]="true"
                            [(ngModel)]="domainIdModel"
                            (ngChange)="updateDomainId()"
                            [options]="domains"
                            [name]="'domain_id'">
                        </form-field-select>
                    </div>
                    <div class="col-48 col-md-8 pr-0">
                        <form-field-select
                            size="medium"
                            label="Users"
                            [hideLabel]="true"
                            [(ngModel)]="userIdModel"
                            (ngChange)="updateUserId()"
                            [options]="users"
                            [name]="'user_id'">
                        </form-field-select>
                    </div>
                    <div class="col-48 col-md-8 pr-0">
                        <form-field-select
                            size="medium"
                            [hideLabel]="true"
                            label="Module"
                            [(ngModel)]="moduleModel"
                            (ngChange)="updateModule()"
                            [options]="modules"
                            [name]="'module'">
                        </form-field-select>
                    </div>
                    <div class="col-48 col-md-auto mr-auto pr-0 pt-2 datepicker-container">
                        <div class="d-flex">
                            <div [ngClass]="{'disable-datepicker': !useDate}">
                                <div class="disable-datepicker-mask"></div>
                                <date-picker
                                    *ngIf="date"
                                    [(date)]="date"
                                    [monDateFormat]="dateFormat"
                                    (dateChange)="onDateChange()"
                                    [options]="options"
                                />
                            </div>
                            <div class="form-check">
                                <input
                                    type="checkbox"
                                    [(ngModel)]="useDate"
                                    [name]="'useDate'"
                                    id="useDate"
                                    class="form-check-input"/>
                                <label class="form-check-label" for="useDate" translate>
                                    Use Datepicker
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="col-48 col-md-auto text-right">
                        <button class="btn btn-border-radius btn-link font-size-1-1 text-decoration-none"
                                ngCsv
                                [data]="exportCsv()"
                                [quoteStrings]="true"
                                fieldSep=";"
                                filename="auditlog.csv"
                                [attr.aria-label]="'Export CSV' | translate"
                                [disabled]="running"
                                type="button">
                            <span class="inline-block">
                                <span *ngIf="!running" class="fas fa-download fa-lg pr-1" aria-hidden="true"></span>
                                <span translate>Export</span>
                            </span>
                        </button>
                        <button type="submit" class="btn btn-border-radius btn-marine-blue">
                            <span class="fas fa-search fa-lg" aria-hidden="true"></span>
                            <span class="font-size-1-1" translate>
                                Apply
                            </span>
                        </button>
                    </div>
                </div>
            </form>
        </div>
        <div class="card-body">
            <table-container
                (onPageChange)="onPageChange($event)"
                (onPerPageChange)="onPageSizeChange($event)"
                [progress]="promise"
                [collection]="logs"
            >
                <table class="table table-hover table-fixed">
                    <thead>
                    <tr>
                        <th class="col-6 col-lg-5" translate>Date</th>
                        <th class="col-8 col-lg-9" translate>By user</th>
                        <th class="col-9 col-lg-6" translate>Domain</th>
                        <th class="col-7 col-lg-5" translate>Module</th>
                        <th class="col-8 col-lg-8" translate>Target</th>
                        <th class="col-10 col-lg-14" translate>Identifier</th>
                        <th class="col-8 col-lg-10" translate>Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let log of logs">
                        <td>
                            <span *ngIf="log.created_at">
                                {{ (log.created_at | monSetMyTimezone) | userDate }}
                            </span>
                        </td>
                        <td class="text-ellipsis">{{ log.author }}</td>
                        <td class="text-ellipsis">{{ log.domain?.title }}</td>
                        <td class="text-ellipsis">
                            {{ getModuleNameFromValue(log.module) }}
                        </td>
                        <td class="text-ellipsis">
                            {{ parseTargetURI(log.target_uri) }}
                        </td>
                        <td class="text-ellipsis">
                            <span *ngIf="log.data?.identifier">{{ log.data?.identifier }}</span>
                            <pre class="text-ellipsis" *ngIf="!log.data?.identifier && log.data?.source_code">{{ log.data?.source_code }}</pre>
                        </td>
                        <td>
                            {{ log.action | underscoreless }}
                            <div class="pull-right">
                                <span class="fas fa-info-circle cursor-pointer"
                                      aria-hidden="true"
                                      ngbTooltip="{{log.data?.comment}}"
                                      [triggers]="'focus hover'"
                                      placement="bottom-left"
                                      [container]="'body'"
                                      *ngIf="log.data?.comment">
                                </span>
                                <button class="btn btn-border-radius btn-link btn-sm text-right"
                                        type="button"
                                        *ngIf="log.data?.changes && !isBlackListed(log.data?.changes) && log.action !== 'delete'"
                                        (click)="showChanges(log)"
                                        translate>
                                    See changes
                                </button>

                                <button class="btn btn-border-radius btn-link btn-sm text-right"
                                        type="button"
                                        *ngIf="log.data && (log.data.source_code || log.data.check_id) &&
                                               !canUndo(log.apiTarget) || isAnUndoLog(log.action)"
                                        (click)="showMore(log)"
                                        translate>
                                    Show Details
                                </button>

                                <div class="btn-group text-right"
                                     *ngIf="log.data && log.data.source_code && !isAnUndoLog(log.action) && canUndo(log.apiTarget)">
                                    <mon-action-menu [monActionMenuItems]="log.dropdown">
                                        <span translate>Action</span>
                                    </mon-action-menu>
                                </div>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </table-container>
        </div>
    </div>
</div>
